import { Helmet } from 'react-helmet-async';

import { VehiclesCards } from './_authenticated._main.vehicles/VehiclesCards';
import { VehiclesTable } from './_authenticated._main.vehicles/VehiclesTable';
import { t } from '../services/translation/translation';

export const VehiclesRoute = () => {
  return (
    <div>
      <Helmet>
        <title>{t('vehicles-route.title')} - Allocab</title>
      </Helmet>
      <h3 className="text-3xl font-bold dark:text-white mb-6">{t('vehicles-route.title')}</h3>
      <div className="hidden xl:block">
        <VehiclesTable />
      </div>
      <div className="xl:hidden">
        <VehiclesCards />
      </div>
    </div>
  );
};
